/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {CreateNonSimulationRoomRequest} from "../model/create-non-simulation-room-request";
import {CreateVirtualRoomRequest} from "../model/create-virtual-room-request";
import {DeleteRequest} from "../model/delete-request";
import {FreeTrainingRoomRequest} from "../model/free-training-room-request";
import {ListData} from "../model/list-data";
import {OccupiedTrainingRoom} from "../model/occupied-training-room";
import {RoomCapability} from "../model/room-capability";
import {SearchParamRequest} from "../model/search-param-request";
import {SelectTrainingRoomRequest} from "../model/select-training-room-request";
import {TrainingRoom} from "../model/training-room";
import {TrainingRoomGroup} from "../model/training-room-group";
import {TrainingRoomGroupView} from "../model/training-room-group-view";
import {TrainingRoomType} from "../model/training-room-type";
import {UpdateTrainingRoomRequest} from "../model/update-training-room-request";
import {UpdateTrainingRoomsRequest} from "../model/update-training-rooms-request";

@Injectable({
    providedIn: "root",
})
export class SimTrainingRoomService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public createNonSimulationRoom(request: CreateNonSimulationRoomRequest) {
        return super.post<TrainingRoom>(`/api/TrainingRoom/CreateNonSimulationRoom`, request);
    }
/**
 * Convenience function for creating virtual rooms with a small set of parameters
 */ 

    public createVirtualRoom(request: CreateVirtualRoomRequest) {
        return super.post<TrainingRoom>(`/api/TrainingRoom/CreateVirtualRoom`, request);
    }

    public deleteTrainingRoom(trainingRoom: TrainingRoom) {
        return super.post<boolean>(`/api/TrainingRoom/DeleteTrainingRoom`, trainingRoom);
    }

    public deleteTrainingRoomGroup(request: DeleteRequest) {
        return super.post<boolean>(`/api/TrainingRoom/DeleteTrainingRoomGroup`, request);
    }

    public freeOccupiedTrainingRoom(request: FreeTrainingRoomRequest) {
        return super.post<void>(`/api/TrainingRoom/FreeOccupiedTrainingRoom`, request);
    }

    public getFilteredTrainingRoomGroups(searchTerm: string, searchColumn: string, sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<TrainingRoomGroup>>(`/api/TrainingRoom/GetFilteredTrainingRoomGroups`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getFilteredTrainingRooms(searchParameters: SearchParamRequest) {
        return super.get<ListData<TrainingRoom>>(`/api/TrainingRoom/GetFilteredTrainingRooms`, {searchParameters: searchParameters}, ["searchParameters"]);
    }

    public getOccupiedNameById(trainingRoomId: string) {
        return super.get<string>(`/api/TrainingRoom/GetOccupiedNameById`, {trainingRoomId: trainingRoomId});
    }

    public getOccupiedTrainingRooms(searchTerm: string, searchColumn: string, sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<OccupiedTrainingRoom>>(`/api/TrainingRoom/GetOccupiedTrainingRooms`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getTrainingRoomById(trainingRoomId: string) {
        return super.get<TrainingRoom>(`/api/TrainingRoom/GetTrainingRoomById`, {trainingRoomId: trainingRoomId});
    }

    public getTrainingRoomGroupById(trainingRoomGroupId: string) {
        return super.get<TrainingRoomGroup>(`/api/TrainingRoom/GetTrainingRoomGroupById`, {trainingRoomGroupId: trainingRoomGroupId});
    }

    public getTrainingRoomGroups() {
        return super.get<TrainingRoomGroup[]>(`/api/TrainingRoom/GetTrainingRoomGroups`, );
    }

    public getTrainingRooms() {
        return super.get<TrainingRoom[]>(`/api/TrainingRoom/GetTrainingRooms`, );
    }

    public getTrainingRoomsByIds(trainingRoomIds: string[]) {
        return super.post<TrainingRoom[]>(`/api/TrainingRoom/GetTrainingRoomsByIds`, trainingRoomIds);
    }

    public getTrainingRoomsGrouped() {
        return super.get<TrainingRoomGroupView[]>(`/api/TrainingRoom/GetTrainingRoomsGrouped`, );
    }

    public getTrainingRoomsGroupedWithFilter(types: TrainingRoomType, capabilities: RoomCapability) {
        return super.get<TrainingRoomGroupView[]>(`/api/TrainingRoom/GetTrainingRoomsGroupedWithFilter`, {types: types, capabilities: capabilities});
    }

    public getTrainingRoomsWithFilter(types: TrainingRoomType, capabilities: RoomCapability) {
        return super.get<TrainingRoom[]>(`/api/TrainingRoom/GetTrainingRoomsWithFilter`, {types: types, capabilities: capabilities});
    }

    public getTrainingRoomThumbnail_Url(trainingRoomId: string, layoutIndex: number) {
        return super.getUrl(`/api/TrainingRoom/GetTrainingRoomThumbnail`, {trainingRoomId: trainingRoomId, layoutIndex: layoutIndex});
    }

    public selectTrainingRoom(request: SelectTrainingRoomRequest) {
        return super.post<boolean>(`/api/TrainingRoom/SelectTrainingRoom`, request);
    }

    public updateTrainingRoom(request: UpdateTrainingRoomRequest) {
        return super.post<boolean>(`/api/TrainingRoom/UpdateTrainingRoom`, request);
    }

    public updateTrainingRoomGroup(trainingRoomGroup: TrainingRoomGroup) {
        return super.post<boolean>(`/api/TrainingRoom/UpdateTrainingRoomGroup`, trainingRoomGroup);
    }

    public updateTrainingRooms(request: UpdateTrainingRoomsRequest) {
        return super.post<boolean>(`/api/TrainingRoom/UpdateTrainingRooms`, request);
    }
}